<template>
  <section>
    <IconoHeader class="index1" />
    <div class="index1 d-flex flex-column justify-center align-center">
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0 mb-6 mt-6">
          <h2
            class="texto-color texto-titulo text-center font-weight-bold nombre"
          >
            {{ '¡' + persona.nombreBienvenida.toUpperCase() + '!' }}

            <!-- <span class="text-capitalize">{{ persona.nombreBienvenida }}</span> -->
          </h2>
        </v-col>
        <div class="text3">Tu crédito</div>
      </v-row>
      <v-row>
        <div class="text2 font-weight-bold">100%</div>
        <div class="text1">en línea te espera</div>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <img
          :src="ObtenerLogoActivaCash"
          alt="logo"
          class="imageActiva d-flex flex-row justify-space-between align-center"
          width="180"
          height="20px"
        />
      </v-row>
      <v-row cols="12" class="mt-14 ma-0 pa-0" justify="center">
        <div class="oferta">Tienes una oferta de crédito preautorizada por</div>
        <div v-if="monto_oferta == 0" class="monto2">
          {{ 'Cargando...' }}
        </div>
        <div class="monto" v-else>
          {{ monto_oferta }}
        </div>
      </v-row>
      <v-row class="mt-14 ma-0 pa-0" justify="center">
        <v-col><div class="info1">SIN COMPROBAR INGRESOS</div> </v-col>

        <v-col
          ><div class="info2">| SIN AVAL</div>
          <dvi class="info1">|</dvi>
          <div class="info23">| SIN PLAZO FORZOSO</div>
        </v-col>
      </v-row>

      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <img
          :src="ObtenerLogo24hrs"
          alt="logo"
          class="d-flex flex-row justify-space-between align-center"
          width="170px"
          height="39px"
        />
      </v-row>
      <div class="nececidadComp"></div>
      <v-row cols="12">
        <div class="text-ine mt-2">
          <img
            :src="ObtenerLogoIne"
            alt="logo"
            class="d-flex flex-row justify-space-between align-center mr-4"
          />
          INE vigente
        </div>
      </v-row>
      <v-row cols="12">
        <div class="text-domi mt-4">
          <img
            :src="ObtenerLogoComprobante"
            alt="logo"
            class="d-flex flex-row justify-space-between align-center imgLogo"
            width="50px"
            height="50px"
          />
          <div class="textComprobante">Comprobante de domicilio</div>
        </div>
      </v-row>

      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-dialog v-model="dialogDocumentos" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="align-self-center btn-customisado"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="quitarClases"
                ><v-icon right light class="iconCostumer"
                  >mdi-arrow-right</v-icon
                >
                <div class="simula">Simula</div>
                tu préstamo</v-btn
              >
              <!-- <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="noInteresado"
                >NO INTERESADO DE MOMENTO<v-icon right light
                  >mdi-arrow-left</v-icon
                ></v-btn
              > -->
            </template>
            <v-card class="ma-0 pa-0" cols="5">
              <v-card-title>Antes de comenzar...</v-card-title>
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >Validaremos tu télefono celular
                <v-chip color="green" outlined>{{ celularOferta }} </v-chip>
                enviando un código de verificación:</v-card-subtitle
              >
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >No olvides tener a la mano los documentos que necesitarás
                durante el proceso:</v-card-subtitle
              >
              <v-list disabled class="ma-0 px-3">
                <v-list-item-group color="primary">
                  <v-list-item
                    class="v-item--active v-list-item--active my-2"
                    v-bind:class="{ 'v-list-item__title': false }"
                    v-for="(item, i) in documentosNecesarios"
                    :key="i"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon v-text="item.icono"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-bold"
                        v-text="item.texto"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-card-actions class="d-flex flex-row justify-end">
                <v-btn
                  @click="continuarAPArametrizacion"
                  :loading="cargando"
                  :disabled="cargando"
                  elevation="2"
                  color="primary"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row justify="center" class="ma-0 pa-0 mt-4 mb-6">
        <div class="imgCNV">
          <img
            :src="ObtenerImageCNVB"
            alt="logo"
            class="d-flex flex-row justify-space-between align-center"
            width="120px"
            height="60px"
          />
        </div>
      </v-row>
    </div>
  </section>
</template>

<script>
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { ObtieneOfertaDigitalMixin } from '@/mixins/credito/ObtieneOfertaDigital.mixin'
import OtpService from '@/servicios/otp'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: { IconoHeader },
  mixins: [InsertaLogMixin, ObtieneOfertaDigitalMixin],
  name: 'BienvenidaConfianza',
  data: () => ({
    dialogDocumentos: false,
    documentosNecesarios: [],
    persona: '',
    tipoPersona: null,
    cargando: false,
    celularOferta: '',
    monto_oferta: 0,
  }),
  created() {
    this.persona = this.$store.getters['persona/obtenerPersona'].datosPersonales
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
    this.celularOferta = this.$store.getters['persona/obtenerCelularOferta']
    this.$gtag.event('telefonoOferta', {
      event_category: 'Enter Page',
      event_label: 'Celular de la oferta',
      value: this.celularOferta,
    })
    this.InsertaLog({ notas: 'Celular de la oferta ' + this.celularOferta })
    this.$store.commit('ESTABLECER_LAYOUT', 'LayoutConfianza')
    this.documentosNecesarios =
      this.$store.getters['personaDocumentos/obtenerDocumentosASolicitar']
    this.obtieneOfertaDigital(this.$attrs.folioDigital)
  },
  computed: {
    ObtenerLogoActivaCash() {
      return require('@/assets/images/Logo Activacash.png')
    },
    ObtenerLogo24hrs() {
      return require('@/assets/images/24hrs.png')
    },
    ObtenerImageCNVB() {
      return require('@/assets/images/CNBV.png')
    },
    ObtenerLogoIne() {
      return require('@/assets/images/card.png')
    },
    ObtenerLogoComprobante() {
      return require('@/assets/images/comprobante.png')
    },
  },
  methods: {
    comenzar() {
      // this.$router.push('Bienvenida')
      // this.$emit('comenzar')
      this.dialogDocumentos = true
    },
    whats() {
      // window.location.href = 'https://wa.me/5215510695948'
      window.open('https://wa.me/5215510695948', '_blank')
    },
    llamar() {
      // window.location.href = 'tel:8003000268'
      window.open('tel:8003000268', '_blank')
    },
    postObtieneOfertaDigital(result) {
      //this.monto_oferta = result.DatosGenerales[0].Monto_Preautorizado
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        minimumFractionDigits: 0,
        currency: 'USD',
      })
      this.monto_oferta = formatter.format(
        result.DatosGenerales[0].Monto_Preautorizado
      )
    },
    async quitarClases() {
      //documento multilinea
      try {
        setTimeout(() => {
          while (
            document.getElementsByClassName('v-list-item__title').length > 0
          ) {
            document
              .getElementsByClassName('v-list-item__title')[0]
              .classList.remove('v-list-item__title')
          }
        }, 50)
      } catch (error) {
        console.error(error)
      }
    },
    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      let result
      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          result.data.Mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    async continuarAVerificacionOtp() {
      await this.enviarOtp()
      this.$router.push('verificacion-otp')
    },
    continuarAPArametrizacion() {
      this.$router.push('parametrizacion')
    },
  },
}
</script>
<style scoped>
@media screen and (max-width: 500px) {
  .texto-color {
    color: white;
  }
}
.btn-customisado {
  border-radius: 20px;
  margin-bottom: 5px;
  margin-bottom: 16px;
  background-color: white;
  text-transform: lowercase !important;
  padding: 20px !important;
}
.nececidadComp {
  background-color: white;
  opacity: 0.2;
  position: absolute;
  width: 100%;
  height: 400px;
  top: 68%;
}
.simula {
  text-transform: capitalize !important;
  margin-right: 2px !important;
}
.textComprobante {
  margin-left: 12px !important;
}
.index1 {
  z-index: 1;
  position: relative;
}
.imgLogo {
  padding: 10px;
}
.imgCNV {
  margin-top: 10px !important;
}
.text1 {
  font-size: 20px;
  width: 85px;
  color: aliceblue;
  margin-left: 10px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400 !important;
}
.text2 {
  font-size: 40px;
  color: rgb(194, 199, 190);
  font-weight: 900 !important;
  font-family: 'Poppins', sans-serif;
}
.text3 {
  font-size: 20px;
  margin-right: 115px;
  color: aliceblue;
  margin-bottom: -14px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400 !important;
}
.row {
  margin-top: 0px !important;
  text-align: left;
}
.nombre {
  font-size: 60px !important;
  color: white;
  font-weight: 900 !important;
  font-family: 'Poppins', sans-serif;
  margin-top: 5px;
}

@font-face {
  font-family: quicksans !important;
  src: local('Montserrat'), url('../../assets/fonts/Montserrat.ttf'),
    format('truetype');
}

.oferta {
  font-size: 23px !important;
  text-align: center;
  color: white;
  font-family: 'Poppins', sans-serif;
  font-weight: 300 !important;
  margin-bottom: 5px;
}
.monto {
  font-size: 46px !important;
  color: #f2c526;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 900 !important;
  margin-bottom: 5px;
}
.monto2 {
  font-size: 36px !important;
  color: #f2c526;
  font-weight: bold !important;
}
.iconCostumer {
  border-radius: 10px;
  margin-right: 10px !important;
  background-color: green;
  padding: 12px !important;
  color: white !important;
}
.info1 {
  color: white;
  font-size: 15px !important;
  text-align: end !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
}
.info2 {
  color: white;
  font-size: 15px !important;
  text-align: start !important;
  margin-bottom: -14px;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
}
.info23 {
  color: white;
  font-size: 15px !important;
  text-align: start !important;
  margin-top: -14px;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
}
.textPart2 {
  color: white;
  margin-top: 19px;
  font-size: 23px;
  margin-left: 2px;
  margin-bottom: 10px;
}
.text-ine {
  margin-top: 60px !important;
  font-size: 18px;
  color: white;
  display: flex;
  align-items: center;
  margin-right: 189px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400 !important;
}
.text-domi {
  margin-bottom: 8%;
  font-size: 18px;
  color: white;
  margin-top: 5px;
  display: flex;
  align-items: center;
  margin-right: 88px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400 !important;
}

.text5 {
  font-size: 18px;
  font-weight: 500;
  color: white;
  margin-top: 7px;
}

@media screen and (min-width: 501px) and (max-width: 1001px) {
  .texto-color {
    color: white;
  }
}
.imageActiva {
  height: 94px;
  margin-top: 35px;
  margin-bottom: 35px;
}
</style>
